import { withDataVersion } from '@hakimo-ui/hakimo/util';
import { AlarmUpdate, DataVersion } from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useUpdateAlarm(
  alarmId: string,
  onSuccess?: (data: null, variables: AlarmUpdate | null) => void,
  dataVersion?: DataVersion
) {
  const url = `/v2/orm/alarm/update/${alarmId}`;

  const request = new Request(url, {
    method: 'PATCH',
  });
  withDataVersion(request, dataVersion);

  return useAuthenticatedMutation<null, AlarmUpdate | null>(request, {
    onSuccessInvalidationKeys: [
      ['alarms'],
      ['alarm', alarmId],
      ['alarm_updates', alarmId],
    ],
    onSuccess,
  });
}

export default useUpdateAlarm;
